import React, { useState, useContext } from "react";
import { padronService, formSubmissionService } from "../services/api";
import { AuthContext } from "../context/AuthContext";

export const FormSubmissionPage = () => {
  const { user } = useContext(AuthContext);
  const isReferente = user?.role?.name === "referente";

  // Modo: "link" (referente genera link) o "full" (carga completa)
  const mode = isReferente ? "link" : "full";
  const [generatedLink, setGeneratedLink] = useState("");
  const [copied, setCopied] = useState(false);

  const [dni, setDni] = useState("");
  const [dniNotFound, setDniNotFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  // Datos del formulario
  const [formData, setFormData] = useState({
    dniDeceased: "",
    namingDeceased: "",
    domicileDeceased: "",
    requestorName: "",
    requestorDni: "",
    entryDate: "",
    period: "",
    cuit: "",
    locality: "",
    province: "",
    concept: "servicio sociales funebre",
    serviceProvider: "",
    invoiceNumber: "",
    notes: "",
  });

  const [attachments, setAttachments] = useState({
    solicitude1: null,
    solicitude2: null,
    deathCertificate1: null,
    deathCertificate2: null,
    dniDeceased: null,
    dniRequestor: null,
  });

  // FunciÃ³n para formatear el DNI con puntos (ej: 43137532 -> 43.137.532)
  const formatDniWithDots = (dniValue) => {
    const clean = dniValue.replace(/\D/g, "");
    if (clean.length === 8) {
      return clean.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2.$3");
    }
    return dniValue;
  };

  const handleDniSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setDniNotFound(false);

    const dniWithDots = formatDniWithDots(dni);

    try {
      const response = await padronService.getPadronByDni(dniWithDots);
      if (response.data.exists) {
        setFormData((prev) => ({
          ...prev,
          dniDeceased: dniWithDots,
          namingDeceased: `${response.data.padron.firstName} ${response.data.padron.lastName}`,
          domicileDeceased: response.data.padron.address || "",
        }));
        setDniNotFound(false);
        setStep(2);
      }
    } catch (error) {
      setDniNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateLink = async () => {
    setLoading(true);
    try {
      const res = await formSubmissionService.generateFormLink();
      const frontendBase = window.location.origin;
      const token = res.data.token;
      const link = `${frontendBase}/form/${token}`;
      setGeneratedLink(link);
    } catch (err) {
      alert(
        "âŒ Error al generar el link: " +
          (err.response?.data?.message || err.message),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(generatedLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      setAttachments((prev) => ({
        ...prev,
        [fieldName]: file,
      }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validar que todos los archivos estÃ¡n presentes
      const requiredFiles = [
        "solicitude1",
        "solicitude2",
        "deathCertificate1",
        "deathCertificate2",
        "dniDeceased",
        "dniRequestor",
      ];

      for (const fileField of requiredFiles) {
        if (!attachments[fileField]) {
          alert(
            `âš ï¸ Por favor, carga el archivo: ${fileField}. Todos los 6 documentos son obligatorios.`,
          );
          setLoading(false);
          return;
        }
      }

      // Crear FormData para enviar archivos
      const formDataWithFiles = new FormData();

      // Agregar datos del formulario
      formDataWithFiles.append("dniDeceased", formData.dniDeceased);
      formDataWithFiles.append("namingDeceased", formData.namingDeceased);
      formDataWithFiles.append("domicileDeceased", formData.domicileDeceased);
      formDataWithFiles.append("requestorName", formData.requestorName);
      formDataWithFiles.append("requestorDni", formData.requestorDni);
      formDataWithFiles.append("entryDate", formData.entryDate);
      formDataWithFiles.append("period", formData.period);
      formDataWithFiles.append("cuit", formData.cuit);
      formDataWithFiles.append("locality", formData.locality);
      formDataWithFiles.append("province", formData.province);
      formDataWithFiles.append("concept", formData.concept);
      formDataWithFiles.append("serviceProvider", formData.serviceProvider);
      formDataWithFiles.append("invoiceNumber", formData.invoiceNumber);
      formDataWithFiles.append("notes", formData.notes);

      // Agregar archivos con nombres esperados por el backend
      formDataWithFiles.append(
        "attachmentSolicitude1",
        attachments.solicitude1,
      );
      formDataWithFiles.append(
        "attachmentSolicitude2",
        attachments.solicitude2,
      );
      formDataWithFiles.append(
        "attachmentDeathCertificate1",
        attachments.deathCertificate1,
      );
      formDataWithFiles.append(
        "attachmentDeathCertificate2",
        attachments.deathCertificate2,
      );
      formDataWithFiles.append(
        "attachmentDniDeceased",
        attachments.dniDeceased,
      );
      formDataWithFiles.append(
        "attachmentDniRequestor",
        attachments.dniRequestor,
      );

      await formSubmissionService.submitFormWithFiles(formDataWithFiles);
      alert("âœ… Solicitud enviada exitosamente");
      resetForm();
      setStep(1);
    } catch (error) {
      alert("âŒ Error al enviar la solicitud: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setDni("");
    setFormData({
      dniDeceased: "",
      namingDeceased: "",
      domicileDeceased: "",
      requestorName: "",
      requestorDni: "",
      entryDate: "",
      period: "",
      cuit: "",
      locality: "",
      province: "",
      concept: "servicio sociales funebre",
      serviceProvider: "",
      invoiceNumber: "",
      notes: "",
    });
    setAttachments({
      solicitude1: null,
      solicitude2: null,
      deathCertificate1: null,
      deathCertificate2: null,
      dniDeceased: null,
      dniRequestor: null,
    });
  };

  const FILE_FIELDS = [
    { key: "solicitude1", label: "Solicitud", desc: "Doc empresa firmada por referente" },
    { key: "solicitude2", label: "Solicitud 2", desc: "Datos del documento" },
    { key: "deathCertificate1", label: "Cert. DefunciÃ³n (Sanatorio)", desc: "Certificado del sanatorio" },
    { key: "deathCertificate2", label: "Cert. DefunciÃ³n (Registro Civil)", desc: "Certificado del registro" },
    { key: "dniDeceased", label: "DNI del Fallecido", desc: "Fotocopia del DNI" },
    { key: "dniRequestor", label: "DNI del Solicitante", desc: "Fotocopia del DNI" },
  ];

  return (
    <main className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-slate-800 mb-6">Carga de Solicitud de Servicio FÃºnebre</h1>

      {/* ===== MODO LINK ===== */}
      {mode === "link" && (
        <div className="card p-6">
          {!generatedLink ? (
            <>
              <p className="text-slate-600 mb-6">
                HacÃ© clic para generar un link Ãºnico. El solicitante lo recibe,
                ingresa el DNI del fallecido y carga la documentaciÃ³n.
              </p>
              <button type="button" onClick={handleGenerateLink} disabled={loading} className="btn-primary">
                {loading ? "Generando..." : "Generar link para el solicitante"}
              </button>
            </>
          ) : (
            <div>
              <p className="font-semibold text-green-700 mb-3">Link generado. Copialo y enviÃ¡selo al solicitante:</p>
              <div className="flex gap-2 items-center">
                <input
                  type="text"
                  readOnly
                  value={generatedLink}
                  onClick={(e) => e.target.select()}
                  className="input flex-1 font-mono text-sm"
                />
                <button
                  type="button"
                  onClick={handleCopyLink}
                  className={`px-4 py-2 rounded-md text-sm font-semibold text-white transition-colors ${copied ? "bg-green-600" : "bg-primary-700 hover:bg-primary-800"}`}
                >
                  {copied ? "Copiado!" : "Copiar"}
                </button>
              </div>
              <button
                type="button"
                onClick={() => setGeneratedLink("")}
                className="mt-4 text-sm text-slate-500 hover:text-slate-700 underline"
              >
                â† Generar otro link
              </button>
            </div>
          )}
        </div>
      )}

      {/* ===== MODO FULL ===== */}
      {mode === "full" && (
        <>
          {step === 1 ? (
            <div className="card p-6">
              <p className="text-slate-600 mb-6">
                IngresÃ¡ el DNI del fallecido para validar su existencia en el padrÃ³n electoral.
              </p>
              <form onSubmit={handleDniSearch} className="space-y-4">
                <div>
                  <label htmlFor="dniFull" className="label">DNI del Fallecido</label>
                  <input
                    id="dniFull"
                    type="text"
                    value={dni}
                    onChange={(e) => setDni(e.target.value)}
                    placeholder="Ej: 12345678"
                    required
                    className="input max-w-xs"
                  />
                </div>
                {dniNotFound && (
                  <div className="rounded-md bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-700">
                    No existe esta persona en el padrÃ³n electoral.
                  </div>
                )}
                <button type="submit" disabled={loading} className="btn-primary">
                  {loading ? "Buscando..." : "Validar DNI en PadrÃ³n"}
                </button>
              </form>
            </div>
          ) : (
            <form onSubmit={handleFormSubmit} className="space-y-5">
              {/* SECCIÃ“N 1: Fallecido */}
              <fieldset className="card p-6">
                <legend className="text-sm font-semibold uppercase tracking-wide text-primary-700 px-1 -mt-3 bg-white">Datos del Fallecido</legend>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                  <div>
                    <label className="label">DNI</label>
                    <input type="text" value={formData.dniDeceased} disabled className="input disabled:bg-slate-100" />
                  </div>
                  <div>
                    <label className="label">Nombres y Apellidos</label>
                    <input type="text" name="namingDeceased" value={formData.namingDeceased} onChange={handleFormChange} className="input" />
                  </div>
                  <div className="sm:col-span-2">
                    <label className="label">Domicilio</label>
                    <input type="text" name="domicileDeceased" value={formData.domicileDeceased} onChange={handleFormChange} className="input" />
                  </div>
                  <div>
                    <label className="label">CUIT</label>
                    <input type="text" name="cuit" value={formData.cuit} onChange={handleFormChange} placeholder="Ej: 20-12345678-9" className="input" />
                  </div>
                  <div>
                    <label className="label">Localidad</label>
                    <input type="text" name="locality" value={formData.locality} onChange={handleFormChange} className="input" />
                  </div>
                  <div>
                    <label className="label">Provincia</label>
                    <input type="text" name="province" value={formData.province} onChange={handleFormChange} className="input" />
                  </div>
                </div>
              </fieldset>

              {/* SECCIÃ“N 2: Solicitante */}
              <fieldset className="card p-6">
                <legend className="text-sm font-semibold uppercase tracking-wide text-primary-700 px-1 -mt-3 bg-white">Datos del Solicitante (Familiar)</legend>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                  <div>
                    <label className="label">Nombre completo *</label>
                    <input type="text" name="requestorName" value={formData.requestorName} onChange={handleFormChange} placeholder="Nombre completo del familiar" required className="input" />
                  </div>
                  <div>
                    <label className="label">DNI del Solicitante *</label>
                    <input type="text" name="requestorDni" value={formData.requestorDni} onChange={handleFormChange} placeholder="DNI del familiar" required className="input" />
                  </div>
                </div>
              </fieldset>

              {/* SECCIÃ“N 3: Servicio */}
              <fieldset className="card p-6">
                <legend className="text-sm font-semibold uppercase tracking-wide text-primary-700 px-1 -mt-3 bg-white">Datos del Servicio</legend>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                  <div>
                    <label className="label">Fecha de Entrada *</label>
                    <input type="date" name="entryDate" value={formData.entryDate} onChange={handleFormChange} required className="input" />
                  </div>
                  <div>
                    <label className="label">PerÃ­odo</label>
                    <input type="text" name="period" value={formData.period} onChange={handleFormChange} placeholder="En funciÃ³n de la fecha" className="input" />
                  </div>
                  <div className="sm:col-span-2">
                    <label className="label">Concepto</label>
                    <input type="text" name="concept" value={formData.concept} onChange={handleFormChange} className="input" />
                  </div>
                  <div>
                    <label className="label">Empresa prestadora *</label>
                    <input type="text" name="serviceProvider" value={formData.serviceProvider} onChange={handleFormChange} required className="input" />
                  </div>
                  <div>
                    <label className="label">Nro de Factura</label>
                    <input type="text" name="invoiceNumber" value={formData.invoiceNumber} onChange={handleFormChange} className="input" />
                  </div>
                  <div className="sm:col-span-2">
                    <label className="label">Nota</label>
                    <textarea name="notes" value={formData.notes} onChange={handleFormChange} placeholder="Notas adicionales..." rows={3} className="input" />
                  </div>
                </div>
              </fieldset>

              {/* SECCIÃ“N 4: Adjuntos */}
              <fieldset className="card p-6">
                <legend className="text-sm font-semibold uppercase tracking-wide text-primary-700 px-1 -mt-3 bg-white">Adjuntos (6 documentos obligatorios)</legend>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                  {FILE_FIELDS.map(({ key, label, desc }) => (
                    <div key={key} className="rounded-lg border border-slate-200 p-3">
                      <p className="text-sm font-semibold text-slate-700">{label}</p>
                      <p className="text-xs text-slate-400 mb-2">{desc}</p>
                      <input
                        type="file"
                        onChange={(e) => handleFileChange(e, key)}
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        required
                        className="text-xs text-slate-600 file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-xs file:font-semibold file:bg-primary-50 file:text-primary-700 hover:file:bg-primary-100"
                      />
                      {attachments[key] && (
                        <p className="mt-1 text-xs text-green-600 font-medium">âœ“ {attachments[key].name}</p>
                      )}
                    </div>
                  ))}
                </div>
                <p className="mt-4 text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
                  Todos los documentos son obligatorios. La solicitud quedarÃ¡ en estado pendiente hasta que sea revisada.
                </p>
              </fieldset>

              {/* Acciones */}
              <div className="flex gap-3">
                <button type="button" onClick={() => { resetForm(); setStep(1); }} disabled={loading} className="btn-secondary">
                  â† AtrÃ¡s
                </button>
                <button type="submit" disabled={loading} className="btn-primary">
                  {loading ? "Enviando..." : "Enviar Solicitud"}
                </button>
              </div>
            </form>
          )}
        </>
      )}
    </main>
  );
};
